import { ComputedRef, Ref } from 'vue';

import { ProjectId, Service, WorkflowId } from '@ply-io/ply-front-shared-utilities';

import { CreationProcess } from '@/components/CreationWizard/types';
import { GetMappedFields } from '@/components/SideBar/types';

export enum EmbeddedAppActionTypes {
	Close = 'close',
	StartCreationProcess = 'start-creation-process',
}

export interface EmbeddedAppEntry {
	init: (setCreationProcess: (cp: CreationProcess) => void, service: ComputedRef<Service | undefined>) => void;
	appProps: {
		allowClose?: boolean;
		showLogo?: boolean;
	};
	appFunctions: {
		openSettings: () => void;
		getMappedFields: GetMappedFields;
		startCreateTile: () => void;
		openEditSetup: (workflowId: WorkflowId) => void;
		openShareWorkflow: (workflowId: WorkflowId) => void;
		editWorkflow: (workflowId: WorkflowId, projectId: ProjectId) => void;
		getCurrentURL: () => string;
		closeSidebar: () => void;
	};
	iframeListeners: Record<EmbeddedAppActionTypes, (...args: unknown[]) => void>;
	emails: Ref<string[]>;
	domains: Ref<string[]>;
}
